"use strict";

define('components/filter_bar/table/bulk_add_as_prospects_to',[], function() {
    var bulkAddAsProspectsToComponent = {
        initWithContext: function(context) {
            var allAddButtons = context.buttonbarNode.find('li.add-prospect');
            allAddButtons.click(function() {
                var addButton = $(this);
                var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();
                var content = {
                    object_type: context.tableFilterBarData.tableObjectType,
                    object_ids: objectIds.join(','),
                    csrf_token: $('meta[name=csrf_token]').attr('content'),
                }

                // We are calling .load rather than using the "remote"
                // property of the modal to ensure that the request is a POST.
                // This is needed because we might need to submit a large number
                // of object IDs.
                var smallModal = $('#small-modal');
                var modalContent = smallModal.find('.modal-content');
                modalContent.load(addButton.data('add-url'), content, function(responseText, textStatus, jqXHR) {
                    // Trigger this event manually since we are not using
                    // the "remote" property.
                    smallModal.trigger('loaded.bs.modal');
                    smallModal.modal({show: true});
                });

                $(document).one('jsq:modalSuccess', function(e, result) {
                    _updateTableOnSuccess(context, result);
                });
            });
        }
    };

    function _updateTableOnSuccess(context, result) {
        var alertMessage = $('#alert-message');
        alertMessage.html('<button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>');
        
        // Not using the standard .alert-dismissable handler since it deletes
        // the entire alert DOM
        var closeButton = alertMessage.find('button.close');
        closeButton.click(function (e) {
            e.preventDefault();
            alertMessage.html('')
                        .removeClass('alert-warning')
                        .removeClass('alert-success')
                        .addClass('hidden');
        });

        if (result.alert_list.length) {
            for (var i = 0; i < result.alert_list.length; i++) {
                var p = $('<p></p>');
                p.text(result.alert_list[i])
                alertMessage.append(p);
            }
            alertMessage.removeClass('alert-success')
                        .addClass('alert-warning')
                        .removeClass('hidden');
        } else {
            var p = $('<p></p>');
            p.text('Added ' + result.new_prospect_count + ' new prospect' +
                   (result.new_prospect_count == 1 ? '' : 's'));
            
            alertMessage.append(p);

            alertMessage.removeClass('alert-warning')
                        .addClass('alert-success')
                        .removeClass('hidden');
        }

        // Update data for contacts, but not if we're creating prospects
        if (context.tableFilterBarData.tableObjectType !== 3 || Object.prototype.hasOwnProperty.call(result, 'new_prospect_count')) return;
    
        result.updated_object_ids.forEach(function(id) {
            var countNode = context.tableFilterBarData.tableInstance.findInCell(id, 'cell-investments', 'span');

            var value = countNode.text().trim();
            if (!value) {
                value = 1;
            } else {
                value++;
            }
            
            countNode.html(value);
        });
    }

    return bulkAddAsProspectsToComponent;
});

